import { render, staticRenderFns } from "./DecretosFirmar.vue?vue&type=template&id=97509508&scoped=true&"
import script from "./DecretosFirmar.vue?vue&type=script&lang=js&"
export * from "./DecretosFirmar.vue?vue&type=script&lang=js&"
import style0 from "./DecretosFirmar.vue?vue&type=style&index=0&id=97509508&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97509508",
  null
  
)

export default component.exports